import React, { useEffect, useState } from 'react'
import Input from "../../../DynamicComp/Input";
import Productmasterimg from './Productmasterimg';
import { postData, putData, getData  } from '../../../../global/Globalapi';
import { showAlert } from '../../../DynamicComp/Alert';
const EditFormDetails = ({ formData, childImages,setFormData,editId,handleImagesUpdate}) => {
  const [refresh,setrefresh]=useState(false);
   const [data,setdata] = useState({});
   const [regionData, setRegionData] = useState([]);
const [branchData, setBranchData] = useState([]);
  console.log("edit id in form detail",editId);
  useEffect(() => {
  fetchRegions();
}, []);

const fetchRegions = async () => {
  try {
    const res = await getData("/regionmaster");
    setRegionData(res.data);
  } catch (error) {
    console.error("Error fetching regions:", error);
  }
};
useEffect(() => {
  if (formData.region_id) {
    fetchBranchesByRegion(formData.region_id);
  } else {
    setBranchData([]);
  }
}, [formData.region_id]);

const fetchBranchesByRegion = async (regionId) => {
  try {
    const res = await getData("/branchmaster");
    
    const filtered = res.data.filter(
      (branch) => branch.region_id == regionId
    );

    setBranchData(filtered);
  } catch (error) {
    console.error("Error fetching branches:", error);
  }
};
    const handleChange = (e) => {
    const { name, value } = e.target;
     setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  useEffect(()=>{
    setrefresh(false)
  },[refresh])
  const handlesubmit=async(e)=>{
     e.preventDefault();
    handleUpdate(e);
    setrefresh(true);
  }
const handleUpdate = async (e) => {
  e.preventDefault(); 

  const formDataToSend = new FormData();

  const imagesData = childImages.map((img, idx) => ({
    file_name: img.file_name || '', 
    displayOrder: img.displayOrder || idx + 1,
    description: img.description || '',
    isNew: img.file instanceof File || img.isNew 
  }));

  formDataToSend.append('images_data', JSON.stringify(imagesData));

  childImages.forEach((img) => {
    if (img.file instanceof File) {
      formDataToSend.append('image_files', img.file);
    }
  });

  try {
    console.log("form data to be send",formDataToSend)
    const response = await postData(`/product_update_edit/${editId}`, formDataToSend, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    console.log("Form data",FormData)
    const res=await putData(`/product-edit_details/${editId}`,formData)
    console.log('Images updated successfully', response);
    if(res){
      console.log('Product details updated successfully', res);
    }
    showAlert({
                              type: 'success',
                              message: data.message || "Product and images updated successfully",
                              title: 'success',
                            });
  } catch (err) {
    console.error(err);
     showAlert({
                              type: 'error',
                              message: data.message || "Error updating images.",
                              title: 'error',
                            });
  }
};
    const inputClassName = "w-full px-2 py-1 text-sm border border-gray-300 rounded-md shadow-sm placeholder-gray-700";
  return (
    <div className="bg-white ">
      <h2 className="text-xl font-semibold mb-4">Edit Product (ID: {editId})</h2>
      <form onSubmit={handlesubmit}>
 <div><div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">

  {/* Region Dropdown */}
  <div>
    <label className="block text-gray-700 font-semibold mb-2">
      Region
    </label>
    <select
      name="region_id"
      value={formData.region_id || ""}
      onChange={handleChange}
      className="w-full px-2 py-1 border border-gray-300 rounded-md"
    >
      <option value="">Select Region</option>
      {regionData.map((region) => (
        <option key={region.region_id} value={region.region_id}>
          {region.region_name}
        </option>
      ))}
    </select>
  </div>

  {/* Branch Dropdown */}
  <div>
    <label className="block text-gray-700 font-semibold mb-2">
      Branch
    </label>
    <select
      name="branch_id"
      value={formData.branch_id || ""}
      onChange={handleChange}
      className="w-full px-2 py-1 border border-gray-300 rounded-md"
    >
      <option value="">Select Branch</option>
      {branchData.map((branch) => (
        <option key={branch.branch_id} value={branch.branch_id}>
          {branch.branch_name}
        </option>
      ))}
    </select>
  </div>

</div>
                                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                                            {!formData.Parent_Id && (
                                              <div className="col-span-1">
                                                  <label htmlFor="title" className="block text-gray-700 font-semibold mb-2">Title</label>
                                                  <Input
                                                      type="text"
                                                      name="productName"
                                                      value={formData.productName || ""}
                                                      onChange={handleChange}
                                                      placeholder="Enter Product Name"
                                                      required={false}
                                                      className={inputClassName}
                                                  />
                                              </div>
                                            )}
                                                {/* All your price inputs */}
                                                <div className="col-span-1"><Input type="text" label="Purchase Price Included GST" name="purchasePriceIncludeGST" value={formData.purchasePriceIncludeGST} onChange={handleChange} placeholder="Enter Purchase Price" required="true" labelColor="text-gray-700 font-semibold" className={inputClassName} /></div>
                                                <div className="col-span-1"><Input type="text" label="Selling Price" name="selling_Price" value={formData.selling_Price} onChange={handleChange} placeholder="Enter Selling Price" className={inputClassName} required="true" /></div>
                                                <div className="col-span-1"><Input type="text" label="CGST %" name="cgst_percent" value={formData.cgst_percent} onChange={handleChange} placeholder="0.00" className={inputClassName} required="true" labelColor="text-gray-700 font-semibold" /></div>
                                                <div className="col-span-1"><Input type="text" label="CGST ₹" name="cgst" value={formData.cgst} onChange={handleChange} placeholder="0.00" className={inputClassName} required="true" labelColor="text-gray-700 font-semibold" disabled={true} /></div>
                                                <div className="col-span-1"><Input type="text" label="SGST %" name="sgstPer" value={formData.sgstPer} onChange={handleChange} placeholder="0.00" className={inputClassName} required="true" labelColor="text-gray-700 font-semibold" /></div>
                                                <div className="col-span-1"><Input type="text" label="SGST ₹" name="sgst" value={formData.sgst} onChange={handleChange} placeholder="0.00" className={inputClassName} required="true" labelColor="text-gray-700 font-semibold" disabled={true} /></div>
                                                <div className="col-span-1"><Input type="text" label="IGST %" name="igstPer" value={formData.igstPer} onChange={handleChange} placeholder="0.00" className={inputClassName} required="true" labelColor="text-gray-700 font-semibold" /></div>
                                                <div className="col-span-1"><Input type="text" label="IGST ₹" name="igst" value={formData.igst} onChange={handleChange} placeholder="0.00" className={inputClassName} required="true" labelColor="text-gray-700 font-semibold" disabled={true} /></div>
                                                <div className="col-span-1"><Input type="text" label="Selling Price With GST" name="sellingPriceGST" value={formData.sellingPriceGST} onChange={handleChange} placeholder="0.00" className={inputClassName} required="true" labelColor="text-gray-700 font-semibold" /></div>
                                               <div className="col-span-1">
    <Input 
        type="text" 
        label="Discount %" 
        name="discountPercent" 
        value={formData.discountPercent} 
        onChange={handleChange} 
        placeholder="0.00" 
        required="true" 
        labelColor="text-gray-700 font-semibold" 
        className={inputClassName} 
    />
</div>
<div className="col-span-1">
    <Input 
        type="text" 
        label="Discount Amount (₹)" 
        name="discountAmount" 
        value={formData.discountAmount} 
        onChange={handleChange} 
        placeholder="Calculated Discount" 
        required={false}
        labelColor="text-gray-700 font-semibold" 
        className={inputClassName} 
        disabled={true} 
    />
</div>
<div className="col-span-1">
    <Input 
        type="text" 
        label="Net Price" 
        name="netPrice" 
        value={formData.netPrice} 
        onChange={handleChange} 
        placeholder="Final Price" 
        required={false}
        labelColor="text-gray-700 font-semibold" 
        className={inputClassName} 
        disabled={true} 
    />
</div>
<div className="col-span-1"><Input type="text" label="MRP" name="MRP" value={formData.MRP} onChange={handleChange} placeholder="MRP" className={inputClassName} required="true" labelColor="text-gray-700 font-semibold" /></div>
<div className="col-span-1">
    <Input 
        type="text" 
        label="Stock" 
        name="initial_stock" 
        value={formData.initial_stock} 
        onChange={handleChange} 
        placeholder="Enter stock" 
        required="true" 
        labelColor="text-gray-700 font-semibold" 
        className={inputClassName}  
    />
</div>
</div>

<div className="mt-6">
    
    <h1 className="text-lg font-semibold text-gray-800 mb-2">Dimension</h1>
     <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
<div className="col-span-1">
    <Input 
        type="text" 
        label="Height(cm)" 
        name="height" 
        value={formData.height} 
        onChange={handleChange} 
        placeholder="Enter height" 
        required="true" 
        labelColor="text-gray-700 font-semibold" 
        className={inputClassName}  
    />
</div>
<div className="col-span-1">
    <Input 
        type="text" 
        label="Width(cm)" 
        name="width" 
        value={formData.width} 
        onChange={handleChange} 
        placeholder="Enter width" 
        required="true" 
        labelColor="text-gray-700 font-semibold" 
        className={inputClassName}  
    />
</div>
<div className="col-span-1">
    <Input 
        type="text" 
        label="Breadth(cm)" 
        name="breadth" 
        value={formData.breadth} 
        onChange={handleChange} 
        placeholder="Enter breadth" 
        required="true" 
        labelColor="text-gray-700 font-semibold" 
        className={inputClassName}  
    />
</div>

<div className="col-span-1">
    <Input 
        type="text" 
        label="Weight(grams)" 
        name="weight" 
        value={formData.weight} 
        onChange={handleChange} 
        placeholder="Enter weight" 
        required="true" 
        labelColor="text-gray-700 font-semibold" 
        className={inputClassName}  
    />
</div>
</div>
</div>
<div className="col-span-5 mt-6">
                            <div className="bg-white p-6 rounded-xl shadow-lg w-full overflow-x-auto mb-8">
                                <Productmasterimg
                                    productId={editId}
                                    onImagesUpdate={handleImagesUpdate}
                                    initialImages={childImages}
                                    key={editId || 'new'}
                                />
                            </div>
                        </div>

      </div>      

        <div className="flex justify-end gap-2">
          <button
            type="submit"
            className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
          >
           Submit
          </button>
        </div>
      </form>
    </div>
  );
}

export default EditFormDetails
